import { setDialogoAbierto } from 'store/slices/uiSlice'

/**
 * Función que maneja los mensajes de respuesta de error y muestra
 * una alerta personalizada según el código de error.
 * @example catch(err => responseMessageHandler(err, dispatch))
 * @param {Object} error - Objeto que contiene información sobre el error ocurrido.
 * @param {Function} dispatch - Función de Redux para hacer dispatch de las acciones.
 */
export const responseMessageHandler = (error, dispatch) => {
  const codigo = error.code || ''

  if (
    codigo === 'auth/invalid-email' ||
    codigo === 'auth/user-not-found' ||
    codigo === 'auth/wrong-password'
  ) {
    // Dialogo de error que se muestra cuando los datos de autenticación no son válidos.
    return dispatch(
      setDialogoAbierto({
        abierto: true,
        tipo: 'error',
        titulo: 'Error de validación',
        mensaje: 'Los datos de autenticación no son validos'
      })
    )
  }

  if (codigo === 'auth/internal-error') {
    // Dialogo de error que se muestra cuando no se ingresó una contraseña.
    return dispatch(
      setDialogoAbierto({
        abierto: true,
        tipo: 'error',
        titulo: 'Error de validación',
        mensaje: 'La contraseña es obligatoria'
      })
    )
  }

  if (codigo === 'resource-exhausted') {
    // Dialogo de error que se muestra cuando el limite de uso diario de Firebase es excedido.
    return dispatch(
      setDialogoAbierto({
        abierto: true,
        tipo: 'error',
        titulo: 'Error del plan',
        mensaje: 'Límite de uso diario excedido. Por favor, regresa mañana o actualiza tu plan.'
      })
    )
  }

  // Dialogo de error genérico que se muestra cuando se produce un error al validar los datos.
  console.error(`Ocurrió un error al validar los datos. Por favor, intenta nuevamente. ${error}`)
  return dispatch(
    setDialogoAbierto({
      abierto: true,
      tipo: 'error',
      titulo: 'Error de validación',
      mensaje: 'Ocurrió un error al validar los datos. Por favor, intenta nuevamente.'
    })
  )
}
